// extracted by mini-css-extract-plugin
export var completionBody = "_c1-2";
export var completionCard = "_c1-0";
export var completionFooter = "_c1-3";
export var completionTitle = "_c1-1";